import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'jml-layout-fullscreen',
  templateUrl: './layout-fullscreen.component.html',
  styleUrls: ['./layout-fullscreen.component.scss']
})
export class LayoutFullscreenComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
